var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollaborate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 219,
    viewBox: "0 0 220 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.096 219C170.571 219 219.596 169.975 219.596 109.5C219.596 49.0248 170.571 0 110.096 0C49.6208 0 0.596008 49.0248 0.596008 109.5C0.596008 169.975 49.6208 219 110.096 219Z",
    fill: "#FE8083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.387 91.571C160.409 82.4565 156.871 73.8051 151.181 66.6179C145.491 59.4306 137.883 54.0013 129.236 50.958L115.448 96.508L161.387 91.571Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.751 57.334L163.533 54.993C166.479 54.6753 169.456 55.139 172.166 56.3375C174.875 57.5359 177.221 59.4269 178.968 61.82",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.479 81.437C171.479 81.437 160.341 83.816 156.879 72.871L143.447 74.314C142.309 74.4362 141.17 74.1015 140.279 73.3837C139.388 72.6658 138.819 71.6235 138.697 70.486C138.575 69.3485 138.909 68.2091 139.627 67.3183C140.345 66.4275 141.387 65.8584 142.525 65.736L146.031 65.359L157.088 64.171",
    fill: "#FE8083"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.479 81.437C171.479 81.437 160.341 83.816 156.879 72.871L143.447 74.314C142.309 74.4362 141.17 74.1015 140.279 73.3837C139.388 72.6658 138.819 71.6235 138.697 70.486V70.486C138.575 69.3485 138.909 68.2091 139.627 67.3183C140.345 66.4275 141.387 65.8584 142.525 65.736L146.031 65.359L157.088 64.171",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.753 84.769L161.148 87.091",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.588 60.7846L178.97 61.8199L181.455 84.9016L191.073 83.8663L188.588 60.7846Z",
    stroke: "black",
    strokeWidth: 2.99923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 151.365C131.002 150.081 139.53 146.254 146.522 140.326C153.514 134.397 158.685 126.61 161.435 117.865L115.448 105.621L121.925 151.365Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.485 130.592L158.556 152.283C158.973 155.216 158.611 158.207 157.505 160.955C156.399 163.704 154.588 166.112 152.256 167.939",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.392 161.11C132.392 161.11 129.64 150.058 140.463 146.228L138.569 132.852C138.409 131.719 138.705 130.569 139.392 129.655C140.08 128.74 141.102 128.136 142.235 127.976C142.796 127.897 143.367 127.928 143.915 128.07C144.464 128.211 144.979 128.459 145.432 128.799C145.884 129.14 146.266 129.566 146.554 130.054C146.842 130.541 147.031 131.081 147.11 131.642L147.604 135.133L149.163 146.145",
    fill: "#FE8083"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.392 161.11C132.392 161.11 129.64 150.058 140.463 146.228L138.569 132.852C138.409 131.719 138.705 130.569 139.392 129.655C140.08 128.74 141.102 128.136 142.235 127.976V127.976C142.796 127.897 143.367 127.928 143.915 128.07C144.464 128.211 144.979 128.459 145.432 128.799C145.884 129.14 146.266 129.566 146.554 130.054C146.842 130.541 147.031 131.081 147.11 131.642L147.604 135.133L149.163 146.145",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.442 172.49L126.396 150.975",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.606 177.519L152.25 167.939L129.258 171.194L130.615 180.774L153.606 177.519Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.143 150.697C104.597 153.042 96.5927 153.51 88.825 152.06C81.0573 150.609 73.7612 147.284 67.5702 142.374C61.3793 137.463 56.4808 131.115 53.3002 123.882C50.1195 116.648 48.753 108.747 49.3191 100.866C49.8852 92.9841 52.367 85.3598 56.5488 78.6551C60.7306 71.9503 66.486 66.3679 73.3152 62.3925C80.1444 58.4172 87.8409 56.1691 95.7362 55.8437C103.631 55.5182 111.487 57.1252 118.62 60.525",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.105 150.708L97.705 102.108L118.615 60.522",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.174 118.833L41.858 138.661C40.5969 141.342 40.0641 144.308 40.3134 147.26C40.5627 150.212 41.5852 153.047 43.278 155.478",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.267 154.794C64.267 154.794 70.149 145.04 60.931 138.194L66.676 125.967C67.1622 124.932 67.2173 123.745 66.8291 122.669C66.441 121.593 65.6413 120.716 64.606 120.229C63.5706 119.743 62.3844 119.688 61.3084 120.076C60.2323 120.464 59.3545 121.264 58.868 122.299L57.368 125.49L52.639 135.557",
    fill: "#FE8083"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.267 154.794C64.267 154.794 70.149 145.04 60.931 138.194L66.676 125.967C67.1622 124.932 67.2173 123.745 66.8291 122.669C66.441 121.593 65.6413 120.716 64.606 120.229C63.5706 119.743 62.3844 119.688 61.3084 120.076C60.2323 120.464 59.3545 121.264 58.868 122.299L57.368 125.49L52.639 135.557",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.739 166.539L72.98 146.872",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1812 174.111L64.296 165.353L43.2793 155.478L39.1645 164.236L60.1812 174.111Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborate);
export default __webpack_public_path__ + "static/media/Collaborate.12185d6379fcdfe6c59c5be831ebc86d.svg";
export { ForwardRef as ReactComponent };